module.exports = __webpack_public_path__ + "static/media/undraw_coming_home_52ir.39cf43c0.svg";